<template>
  <div class="about-us">
    <div class="header"></div>
    <div class="main">
      <p class="main-title">公司简介</p>
      <p class="main-content">
        四川省天府再生资源集团有限公司是四川省委、省政府直接部署，省供销社推动落地的省级再生资源龙头企业，致力于打造省级再生资源回收利用产业牵引平台，系四川省供销农资集团有限公司全资企业，为全省再生资源回收利用行业注入全新动能。
      </p>
      <p class="main-content">
        公司自成立以来，坚定秉持“精准定位、精干高效、精选项目、精进发力”四精理念，按照“做规模、上体量、见效益、树形象”的总体思路，明确了“立足两新两重，深耕循环利用，布局产业集群，引领低碳发展，打造百亿集团”的发展战略；构建起以公司为“链主”，以省再生资源行业协会和咨询服务专家团队为“两翼”，以回收利用体系建设、环保科技（含研发）、循环利用为主攻业务板块的“一主两翼三大主攻方向”发展格局。
      </p>
      <div class="main-bg">
        <img src="~@/assets/recycling/index/about-main.png" alt="" />
        <img src="~@/assets/recycling/index/about-main1.png" alt="" />
      </div>
      <p class="main-content">
        公司现有参控股子公司7家，布局落地了达州报废汽车拆解基地、二手汽车交易市场及汽博中心，广安再生塑料加工基地、广元废铝（铜）分拣加工中心等产业项目；正积极推进废纸板回收、废旧家电拆解和省级“公物仓”建设等项目实施；着力搭建“天府再生云”平台作为全省行业级综合数字赋能平台，为行业产业数字化管理和信息化运营提供智能化支持；在推进业务闭环和牵引行业健康发展方面，取得了布局有序、开局有力的良好成效。
      </p>
    </div>
    <bottom-url class="bottomUrl" />
  </div>
</template>
<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
export default {
  components: {
    BottomUrl,
  },
};
</script>
<style scoped lang="less">
@media screen and (max-width: 768px) {
  .header {
    width: 100% !important;
    height: 120px  !important;
    //line-height: 100px  !important;
  }
  .main {
    width: 100% !important;
    padding: 10px !important;
  }
  .main-title {
    font-size: 16px !important;
  }
  .main-content {
    font-size: 14px !important;
  }
  .main-bg {
    img {
      width:50% !important;
      height: auto !important;
    }
  }
}
.about-us {
  font-family: 微软雅黑;
  width: 100%;
  .header {
    width: 100%;
    height: 280px;
    line-height: 240px;
    text-align: center;
    background: url('~@/assets/recycling/index/about-us-bg.png') center/cover no-repeat;
    color: #ffffff;
    font-size: 36px;
    font-weight: 400;
    letter-spacing: 12px;
  }
  .main {
    width: 1080px;
    margin: 50px auto 84px;
    text-align: center;
    .main-title {
      color: rgb(34, 34, 34);
      font-size: 30px;
      font-weight: 700;
      letter-spacing: 4px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0;
      &::before,
      &::after {
        content: '';
        width: 300px;
        height: 1px;
        background: rgb(221, 221, 221);
        margin: 0 15px;
      }
    }
    .main-content {
      margin-top: 44px;
      color: rgb(77, 81, 90);
      font-size: 20px;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0px;
      text-align: left;
      text-indent: 2em;
    }
    .main-bg {
      margin-top: 37px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 537px;
        height: 321px;
      }
    }
  }
}
.bottomUrl {
  margin-top: 60px;
}
</style>
